import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';

/**
 * Assign Role to User Use Case
 * Assigns a role to a user
 */
export class AssignRoleToUserUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(userId: string, roleId: string): Promise<void> {
        await this.roleRepository.assignRoleToUser(userId, roleId);
    }
}
